"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_link_1 = require("apollo-link");

var AuthHeadersLink_1 = require("./AuthHeadersLink");

var TokenRefreshLink_1 = require("./TokenRefreshLink");

var AuthLink =
/*#__PURE__*/
function (_apollo_link_1$Apollo) {
  _inherits(AuthLink, _apollo_link_1$Apollo);

  function AuthLink(authLinkParameters) {
    var _this;

    _classCallCheck(this, AuthLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthLink).call(this));
    var authHeadersLink = new AuthHeadersLink_1.AuthHeadersLink(authLinkParameters);
    var tokenRefreshLink = new TokenRefreshLink_1.TokenRefreshLink(authLinkParameters);
    _this.link = apollo_link_1.ApolloLink.from([tokenRefreshLink, authHeadersLink]);
    return _this;
  }

  _createClass(AuthLink, [{
    key: "request",
    value: function request(operation, forward) {
      return this.link.request(operation, forward);
    }
  }]);

  return AuthLink;
}(apollo_link_1.ApolloLink);

exports.AuthLink = AuthLink;